
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 1.333c-1.091 0-1.979.888-1.979 1.98 0 1.07.838 1.937 1.93 1.974a.337.337 0 01.091 0h.029A1.974 1.974 0 006.98 3.312c0-1.091-.888-1.979-1.98-1.979zM7.116 6.396c-1.162-.775-3.058-.775-4.229 0-.529.354-.82.833-.82 1.346 0 .512.291.987.816 1.337.583.392 1.35.588 2.117.588.766 0 1.533-.196 2.116-.588.525-.354.817-.83.817-1.346-.004-.512-.292-.987-.817-1.337z","fill":"#838883"}})])
          )
        }
      }
    